import classNames from 'classnames'
import css from '../../global-nav.scss'

import { findPath, storePath } from 'lib/urls'

interface MinimalSiteNavSectionProps {
  trackClick: (eventCta: string) => void
}

const MinimalSiteNavSection = ({ trackClick }: MinimalSiteNavSectionProps) => (
  <>
    <li className={classNames('hidden-xs', css.navLink)}>
      <a href={storePath} onClick={() => trackClick('Shop')}>
        Shop
      </a>
    </li>

    <li className={classNames('hidden-xs', css.navLink)}>
      <a href={findPath} onClick={() => trackClick('Find Registry')}>
        Find Registry
      </a>
    </li>
  </>
)

export default MinimalSiteNavSection
